import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class EquipmentHasUnitsModel extends BaseModel {

    constructor() {
        super({
                name: "equipment_has_units",
                tableName: 'equipment_has_unit',
                label: "Thiết bị",
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: "id",
                    display: false
                },
                unit_id: { 
                    name: 'unit_id',
                    display: false
                },
                equipment_id: { 
                    name: 'equipment_id',
                    display: false
                }

            },
            )
    }

}